import { useState } from 'react'
import { saveAs } from 'file-saver';
import { OfficialFormatDateWithYear } from '../../utilities/FormatDate';
import ConvertDemographicsToString from '../../utilities/ConvertDemographicsToString';
import { LoadingButton } from '../Loading/LoadingButton';

export const ExportFeedingDemographicsCSV = ({facility, patients}) => {

    const [loading, setLoading] = useState(false);

    const downloadCSV = () => {
        setLoading(true);

        if (patients.length > 0) {
            
            const csvString = ConvertDemographicsToString(facility, patients);

            // Create a Blob from the CSV string
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

            let fileName = `AWS - ${facility.name} -`;
            fileName += `${OfficialFormatDateWithYear(Date.now()).replace("/","-").replace(":", "-")}.csv`

            saveAs(blob, fileName);
        }
        setLoading(false);
    };


    return (
        <LoadingButton
            title="Download Demographics"
            onClick={ downloadCSV }
            loading={ loading }
        />
    )
}
